<template>
    <v-container fluid class="pt-0">
        <v-row align="center" justify="center" >
            <v-col cols="12" sm="12" md="12">
                <v-card elevation=24 class="card-course-max">
                     <v-card-title>
                        Add Type
                        <div class="flex-grow-1"></div>
                        <!-- <v-btn color="primary" @click="$router.push('/idtypelist')">ID Type List</v-btn> -->
                     </v-card-title>
                    <v-card-text>
                         <v-divider></v-divider>
                        <v-form v-model="valid" enctype="multipart/form-data" id="createtype">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <h4 class="title">Type Information</h4>
                                    </v-col>
                                </v-row>
                                <!-- <v-row align="center">


                                    <v-col cols="3" md="3" class="font-weight-bold" style="font-size:18px;" >
                                        {{$t('zz_status')}}
                                    </v-col>
                                    <v-col cols="3" md="3">
                                        <v-switch label="" v-model="status" color="success"></v-switch>
                                    </v-col>
                                </v-row> -->
                                 <v-row>
                                    <v-col cols="12" md="12">
                                        <v-text-field
                                        v-model="name"
                                        name="name"
                                        label="Type Name"
                                        required
                                        v-validate="'required|max:255'"
                                        :error-messages="errors.collect('name')"
                                        data-vv-name="name"
                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        Description
                                    </v-col>

                                </v-row>

                                <v-row>

                                    <!-- <v-col cols="6" md="6">
                                        <v-select v-model="showon" item-text="name" item-value="value"
                                        :items="showonlist" label="Show"></v-select>
                                    </v-col> -->
                                    <v-col cols="12" md="12">

                                          <!-- <v-textarea
                                            v-model="description"
                                            name="description"
                                            label="Course Description"
                                            ></v-textarea> -->

                                            <editor
                                            api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                            initialValue=""
                                            label="Description"
                                            v-model="description"
                                            :init="editorConfigDescription"
                                            ></editor>

                                    </v-col>

                                     <!-- <v-file-input
                                        accept="image/png, image/jpeg, image/bmp"
                                        placeholder="Pick an Logo"
                                        prepend-icon="mdi-camera"
                                        label="Course Image"
                                        name="image"
                                        id="image">
                                    </v-file-input> -->

                                </v-row>
                                <!-- <v-row>
                                    <v-col cols="12" md="6" sm="6">

                                        <Cropper classname="cropper" :src="mainimg" @change="onChangeImage" :stencilProps="{aspectRatio: 1}"/>



                                        <v-row>
                                            <v-col cols="12" md="12" sm="12" align="center">
                                                  <v-btn color="primary" @click="$refs.imgfile.click()">

                                                    <input type="file" ref="imgfile" @change="mainim($event)" accept="image/*" class="d-none" id="image"/>Upload  Image
                                                  </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                        <v-col col="12" md="6" sm="6">
                                            <img style="max-width:100%"  :src="image"  class="grey lighten-2"  max-height="300"  v-if="image!=null" />
                                        </v-col>
                                </v-row> -->
                                <v-divider></v-divider>
                                <div class="my-3">
                                <v-btn color="blue" @click="submit">{{$t('zz_save')}}</v-btn>
                                </div>
                            </v-container>
                        </v-form>
                    </v-card-text>

                </v-card>
            </v-col>
        </v-row>

    </v-container>


</template>
<script>
import Vue from 'vue'
import VeeValidate from "vee-validate";
import { Cropper } from 'vue-advanced-cropper'
import Editor from '@tinymce/tinymce-vue'


Vue.use(VeeValidate);
export default{

    props:
    {
        source: String
    },
    data: () => ({
        id:'',
        pricetext:'',
        editorData: '',
        editorConfigDescription: {height: 200,
            menubar: false,
            //  plugins: [
            //    'advlist autolink lists link image charmap print preview anchor',
            //    'searchreplace visualblocks code fullscreen',
            //    'insertdatetime media table paste code wordcount autoresize'
            //  ],
            //
            // toolbar:' bold italic | alignleft aligncenter alignright alignjustify'

            toolbar: 'undo redo | styleselect | cut copy paste| bold italic | alignleft aligncenter alignright alignjustify | outdent indent'
        },
        showon: "",
        showonmenu:true,
        status:true,

        showonlist: [{name:"True",value:"1"}, {name:"False",value:"0"}],

        business_id:0,
        business:[],
        valid: true,
        name:"",
        description:"",
        dictionary:
        {
                    attributes: {
                        name: "ID Type Name",
                    },
                    custom: {}
        },
        mainimg:null,
        image:null,
        coordinates: {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        },
    }),
    created()
    {
        // if (this.$route.params.cid) {
        //     this.id = this.$route.params.cid;
        // }
    },
    mounted()
    {
        this.$validator.localize("en", this.dictionary);
    },
    components: {
        'editor': Editor,

      Cropper
    },
    methods: {
        onChangeImage({coordinates, canvas})
        {
            this.coordinates = coordinates

            this.image = canvas.toDataURL()
        },
        mainim(event)
        {
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0])
            {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.mainimg = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
        dataURLtoFile(dataurl, filename)
        {

            var arr = dataurl.split(','),
                  mime = arr[0].match(/:(.*?);/)[1],
                  bstr = atob(arr[1]),
                  n = bstr.length,
                  u8arr = new Uint8Array(n);

            while(n--){
                  u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
        },
        submit() {
            let th = this;
            if (this.$validator.validateAll()) {
                let fd = new FormData(document.getElementById("createtype"));



                if(localStorage.getItem('business'))
                {
                    this.business=JSON.parse(localStorage.getItem('business'));
                    fd.append('business_id',this.business['id']);

                }
                else
                {
                    fd.append('business_id',0);

                }

                //fd.append('showon',this.showon);



                if(this.description=='')
                    {
                        fd.append('description','');

                    }
                    else
                    {
                        fd.append('description',this.description);
                    }





                this.$http
                .post(this.$apidomain+"createtypepwa", fd)
                .then(res => {
                    if(res.data.success)
                    {

                        this.$router.push({name:'typelist'});

                     //this.$router.push("/courselist");
                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            }
        }
}

}
</script>
<style>
.card-course-max{
    /*flex: 1 1 150px;   Stretching: */
    flex: 0 1 400px; /*  No stretching: */
    margin: 5px;
  }

</style>
